import React, { useState, useEffect } from "react";
import { StyledStoreDetails } from "./StoreDetails.style";
import { useForm } from "components/molecules/Form";
import Form from "components/molecules/Form/Form";
import Field from "components/molecules/Field";
import Button from "components/molecules/Button";
import { Autocomplete } from "@react-google-maps/api";
import manageStores from "services/manageSores";

const servicesData = [
  {
    label: "Delivery",
    value: "Delivery",
  },
  {
    label: "Pickup",
    value: "Pickup",
  },
];

const StoreDetails = ({ editBranch, setFormData, setActiveTab }) => {
  const [form] = useForm();
  const [address, setAddress] = useState({
    street_address: "",
    city: "",
    state: "",
    country: "",
    postal_code: "",
    latLang: {
      lat: null,
      lng: null,
    },
  });
  const [cuisines, setCuisines] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch available cuisines
  useEffect(() => {
    const fetchCuisines = async () => {
      try {
        const searchQuery = {
          page: 1,
          pageSize: 100,
          searchText: "",
          getAll: true,
        };
        const response = await manageStores.getCuisines(searchQuery);
        setCuisines(response.cuisines || []);
      } catch (error) {
        console.error("Failed to fetch cuisines:", error);
      }
    };
    fetchCuisines();
  }, []);

  // Populate form when editing (wait for cuisines to load)
  useEffect(() => {
    if (editBranch && cuisines.length > 0) {
      console.log("EditBranch data:", editBranch);
      console.log("Available cuisines:", cuisines);

      // Small delay to ensure form is ready
      setTimeout(() => {
        // Match cuisines with available options
        const selectedCuisines =
          editBranch.cuisines?.map((storeCuisine) => {
            // Find matching cuisine from available cuisines
            const matchedCuisine = cuisines.find(
              (availableCuisine) =>
                availableCuisine._id === storeCuisine._id ||
                availableCuisine.name === storeCuisine.name ||
                availableCuisine._id === storeCuisine ||
                availableCuisine.name === storeCuisine,
            );

            return matchedCuisine
              ? {
                  label: matchedCuisine.name,
                  value: matchedCuisine._id,
                }
              : {
                  label: storeCuisine.name || storeCuisine,
                  value: storeCuisine._id || storeCuisine,
                };
          }) || [];

        const formValues = {
          storeName: editBranch.name || editBranch.title,
          storeEmail: editBranch.store_email || editBranch.email || "",
          cuisines: selectedCuisines,
          upload_image: editBranch.store_logo,
          upload_banner: editBranch.cover_banner,
          serviceType: [
            ...(editBranch.service_types?.delivery
              ? [{ label: "Delivery", value: "Delivery" }]
              : []),
            ...(editBranch.service_types?.pickup
              ? [{ label: "Pickup", value: "Pickup" }]
              : []),
          ],
        };

        console.log("Selected cuisines for form:", selectedCuisines);

        console.log("Setting form values:", formValues);
        form.setFieldsValue(formValues);

        if (editBranch.address) {
          setAddress(editBranch.address);
          // Also set the address field value for the form
          form.setFieldsValue({
            ...formValues,
            address: editBranch.address.street_address,
          });
        }
      }, 100);
    }
  }, [editBranch, form, cuisines]);

  const handleSubmit = (e) => {
    setLoading(true);
    const stepOne = {
      storeName: e?.storeName,
      storeEmail: e?.storeEmail,
      address: address,
      cuisines: e?.cuisines,
      upload_image: e?.upload_image,
      upload_banner: e?.upload_banner,
      serviceType: e?.serviceType,
    };
    setFormData((prev) => ({
      ...prev,
      form1: { ...stepOne },
    }));
    setActiveTab(1);
    setLoading(false);
  };

  const handlePlaceSelect = (place) => {
    if (place.geometry && place.geometry.location) {
      // Helper function to extract specific values
      const getAddressComponent = (type) => {
        const component = place.address_components.find((comp) =>
          comp.types.includes(type),
        );
        return component ? component.long_name : "";
      };
      setAddress({
        street_address: place?.formatted_address || "",
        city: getAddressComponent("locality"),
        state: getAddressComponent("administrative_area_level_1"),
        country: getAddressComponent("country"),
        postal_code: getAddressComponent("postal_code"),
        latLang: {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
      });
    }
  };
  return (
    <StyledStoreDetails>
      <Form form={form} onSubmit={handleSubmit}>
        <Form.Item
          label="Store name *"
          type="text"
          rounded
          name="storeName"
          lg
          placeholder="Enter Text"
          $bgWhite
          rules={[
            {
              required: true,
              message: "Store name is required",
            },
          ]}
        >
          <Field />
        </Form.Item>
        <Form.Item
          label="Store Email *"
          type="text"
          rounded
          name="storeEmail"
          lg
          placeholder="Enter Email"
          $bgWhite
          rules={[
            {
              required: true,
              message: "Store Email is required",
            },
          ]}
        >
          <Field />
        </Form.Item>

        <Form.Item
          label="Cuisines *"
          type="select"
          rounded
          name="cuisines"
          lg
          placeholder="Select Cuisines"
          $bgWhite
          isMulti
          options={cuisines.map((cuisine) => ({
            label: cuisine.name || cuisine,
            value: cuisine._id || cuisine,
          }))}
          rules={[
            {
              required: true,
              message: "At least one cuisine is required",
            },
          ]}
        >
          <Field />
        </Form.Item>

        <Autocomplete
          onLoad={(autocomplete) =>
            autocomplete.addListener("place_changed", () =>
              handlePlaceSelect(autocomplete.getPlace()),
            )
          }
          options={{ componentRestrictions: { country: "PK" } }}
        >
          <div className="input map-input locate-input">
            <Form.Item
              label="Address *"
              type="text"
              placeholder="123 Main St, City, State"
              name="address"
              value={address.street_address || ""}
              onChange={(e) => {
                const street_address = e.target.value;
                setAddress((prev) => ({
                  ...prev,
                  street_address,
                }));
                form.setFieldsValue({
                  address: street_address,
                });
              }}
              parentClass="map-input-field"
              $bgWhite
              rules={[
                {
                  required: true,
                  message: "Business address is required",
                },
              ]}
            >
              <Field />
            </Form.Item>
          </div>
        </Autocomplete>

        <div className="upload-wrap">
          <Form.Item
            label={
              <>
                <span className="label-title">Upload Your Logo *</span>
                <span className="size-desc">Recommended - Size: 150×150px</span>
              </>
            }
            type="img"
            rounded
            name="upload_image"
            lg
            uploadTitle="Drag & drop or click to upload JPG, PNG or SVG"
            disc="Upload Logo"
            $bgWhite
            // error={error?.logoError}
            rules={[
              {
                required: true,
                message: "Image is required",
              },
            ]}
          >
            <Field />
          </Form.Item>
          <Form.Item
            label={
              <>
                <span className="label-title">Upload Your Cover Banner *</span>
                <span className="size-desc">
                  Recommended - Size: 1317×440px
                </span>
              </>
            }
            type="img"
            rounded
            name="upload_banner"
            lg
            uploadTitle="Drag & drop or click to upload JPG, PNG or SVG"
            disc="Upload Banner"
            $bgWhite
            // error={error?.bannerError}
            rules={[
              {
                required: true,
                message: "Banner is required",
              },
            ]}
          >
            <Field />
          </Form.Item>

          <Form.Item
            label="Service Types *"
            type="select"
            rounded
            name="serviceType"
            lg
            placeholder="Select Service Types"
            $bgWhite
            isMulti
            options={servicesData}
            rules={[
              {
                required: true,
                message: "Please select at least one service type",
              },
            ]}
          >
            <Field />
          </Form.Item>
        </div>

        <div className="btn-holder">
          {editBranch ? (
            <Button lg loader={loading}>
              Save Changes
            </Button>
          ) : (
            <Button lg loader={loading}>
              Save & Continue
            </Button>
          )}
        </div>
      </Form>
    </StyledStoreDetails>
  );
};

export default StoreDetails;
